import type { SVGProps } from 'react';

const SvgVersions = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M20.53 14.15 17.09 12l3.44-2.15c.29-.18.47-.5.47-.85s-.18-.67-.47-.85l-8-5c-.32-.2-.74-.2-1.06 0l-8 5c-.29.18-.47.5-.47.85s.18.67.47.85L6.91 12l-3.44 2.15c-.29.18-.47.5-.47.85s.18.67.47.85l8 5a1.01 1.01 0 0 0 1.06 0l8-5c.29-.18.47-.5.47-.85s-.18-.67-.47-.85M12 5.18 18.11 9 12 12.82 5.89 9zm0 13.64L5.89 15l2.91-1.82 2.67 1.67a1.01 1.01 0 0 0 1.06 0l2.67-1.67L18.11 15z"
    />
  </svg>
);
export default SvgVersions;
